export default "__VITE_ASSET__XLCG9_I6__"